import * as projectsActions from './actions';
import * as projectsSelectors from './selectors';
import * as projectsOperations from './operations';
import * as projectsSchemas from './schema';
import projectsTypes from './types';
import reducer from './reducers';

export {
  projectsActions,
  projectsSelectors,
  projectsOperations,
  projectsSchemas,
  projectsTypes,
};

export default reducer;
